import * as yup from 'yup';
import validator from 'validator';

import { TURKEY_ID } from '@constants/constants';

type DatePayload = {
  day: number;
  month: number;
  year: number;
};
const defaultDateValidator = (date: DatePayload) => !!date;
export const BaseDateSchema =
  (customValidator = defaultDateValidator) =>
  () =>
    yup
      .string()
      .customValidation({
        validator: (value) => {
          const wellFormatted = validator.isDate(value, {
            format: 'DD/MM/YYYY',
          });
          const [day, month, year] = value.split('/').map((x) => +x ?? 0);
          return wellFormatted && customValidator({ day, month, year });
        },
        invalid: 'Lütfen  geçerli bir  Doğum tarihi giriniz.',
        empty: 'Doğum tarihi alanı boş bırakılamaz.',
      })
      .required('Doğum tarihi alanı boş bırakılamaz.');

export const BaseDateSchemaNullable =
  (customValidator = defaultDateValidator) =>
  () =>
    yup
      .string()
      .customValidation({
        validator: (value) => {
          const wellFormatted = validator.isDate(value, {
            format: 'DD/MM/YYYY',
          });
          const [day, month, year] = value.split('/').map((x) => +x ?? 0);
          return wellFormatted && customValidator({ day, month, year });
        },
        invalid: 'Lütfen  geçerli bir  Doğum tarihi giriniz.',
        empty: '',
      })
      .nullable();

const MIN_ALLOWED_YEAR = 1753;
export const BirthDateSchema = BaseDateSchema(
  ({ year }) => year >= MIN_ALLOWED_YEAR
);

export const BirthDateSchemaNullable = BaseDateSchemaNullable(
  ({ year }) => year >= MIN_ALLOWED_YEAR
);

export const LocationsSchema = () => ({
  countryId: yup.number().required('Bu alanı boş bırakamazsınız'),
  cityId: yup
    .number()
    .moreThan(0, 'Bu alanı boş bırakamazsınız')
    .required('Bu alanı boş bırakamazsınız'),
  districtId: yup.mixed().when(['countryId', 'cityId'], {
    is: (countryId: number, cityId: number) =>
      +countryId === +TURKEY_ID && cityId,
    then: yup
      .number()
      .moreThan(0, 'Bu alanı boş bırakamazsınız')
      .required('Bu alanı boş bırakamazsınız'),
    otherwise: yup.mixed(),
  }),
});

export const LoginFormSchema = yup.object().shape({
  email: yup
    .string()
    .email('Lütfen geçerli bir e-posta giriniz.')
    .max(255)
    .required('E-posta alanı boş bırakılamaz.'),
  password: yup.string().nullable().required('Şifre alanı boş bırakılamaz.'),
});

export const PasswordSchema = yup.object().shape({
  password: yup
    .string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,12}$/,
      'Şifreniz 6-12 karakter (?, ! vb. özel karakter içermemelidir), en az 1 büyük 1 küçük harf ve 1 rakamdan oluşmalıdır.'
    )
    .required('Şifre alanı boş bırakılamaz.'),
  passwordAgain: yup
    .string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,12}$/,
      'Şifreniz 6-12 karakter (?, ! vb. özel karakter içermemelidir), en az 1 büyük 1 küçük harf ve 1 rakamdan oluşmalıdır.'
    )
    .oneOf(
      [yup.ref('password'), null],
      'Girdiğiniz şifreler birbiriyle aynı olmalı.'
    ),
});
